import { style } from '@vanilla-extract/css'

const button = style({
  boxSizing: 'border-box',
  fontFamily: 'Inter Variable, sans-serif',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '1.5',
  textAlign: 'center',
  textDecoration: 'none',
  color: 'white',
  backgroundColor: '#252525',
  borderRadius: '32px',
  cursor: 'pointer',
  selectors: {
    '&:disabled': {
      backgroundColor: '#CCCCCC',
    },
  },
})

const small = style({
  fontSize: '13px',
  padding: '8px 16px',
})

const medium = style({
  fontSize: '18px',
  padding: '16px 24px',
})

const primary = style({
  backgroundColor: '#E46327',
})

const secondary = style({
  backgroundColor: 'white',
  color: '#252525',
  border: '1.5px solid #252525',
  selectors: {
    [`&${small}`]: {
      padding: '6.5px 14.5px',
    },
    [`&${medium}`]: {
      padding: '14.5px 22.5px',
    }
  }
})

const danger = style({
  backgroundColor: '#ED0006',
})

const fluid = style({
  width: '100%',
})

export const styles = {
  button,
  small,
  medium,
  primary,
  secondary,
  danger,
  fluid,
}
